module.exports = __webpack_public_path__ + "img/CAT_CHROMATOGRAPHY.5401ec14.svg";